import { jsx as c, Fragment as nr, jsxs as h } from "react/jsx-runtime";
import { useRef as N, useEffect as or } from "react";
import "./client-DHHkGJP0.mjs";
import { a as I } from "./common-utils-DjDyp7mO.mjs";
import "./js.cookie-Cz6eSHLt.mjs";
import { c as m, g as ir } from "./_commonjsHelpers-DaMA6jEr.mjs";
var sr = Object.prototype;
function cr(r) {
  var e = r && r.constructor, t = typeof e == "function" && e.prototype || sr;
  return r === t;
}
var J = cr;
function ur(r, e) {
  return function(t) {
    return r(e(t));
  };
}
var fr = ur, gr = fr, br = gr(Object.keys, Object), pr = br, lr = J, vr = pr, yr = Object.prototype, dr = yr.hasOwnProperty;
function jr(r) {
  if (!lr(r))
    return vr(r);
  var e = [];
  for (var t in Object(r))
    dr.call(r, t) && t != "constructor" && e.push(t);
  return e;
}
var mr = jr, $r = typeof m == "object" && m && m.Object === Object && m, q = $r, Tr = q, _r = typeof self == "object" && self && self.Object === Object && self, hr = Tr || _r || Function("return this")(), f = hr, Sr = f, Ar = Sr.Symbol, X = Ar, B = X, Q = Object.prototype, Or = Q.hasOwnProperty, wr = Q.toString, d = B ? B.toStringTag : void 0;
function Pr(r) {
  var e = Or.call(r, d), t = r[d];
  try {
    r[d] = void 0;
    var o = !0;
  } catch {
  }
  var n = wr.call(r);
  return o && (e ? r[d] = t : delete r[d]), n;
}
var xr = Pr, kr = Object.prototype, Er = kr.toString;
function Mr(r) {
  return Er.call(r);
}
var Nr = Mr, F = X, Ir = xr, Br = Nr, Fr = "[object Null]", Cr = "[object Undefined]", C = F ? F.toStringTag : void 0;
function Lr(r) {
  return r == null ? r === void 0 ? Cr : Fr : C && C in Object(r) ? Ir(r) : Br(r);
}
var _ = Lr;
function Dr(r) {
  var e = typeof r;
  return r != null && (e == "object" || e == "function");
}
var Y = Dr, Rr = _, Vr = Y, Gr = "[object AsyncFunction]", Ur = "[object Function]", Kr = "[object GeneratorFunction]", Hr = "[object Proxy]";
function zr(r) {
  if (!Vr(r))
    return !1;
  var e = Rr(r);
  return e == Ur || e == Kr || e == Gr || e == Hr;
}
var Z = zr, Wr = f, Jr = Wr["__core-js_shared__"], qr = Jr, S = qr, L = function() {
  var r = /[^.]+$/.exec(S && S.keys && S.keys.IE_PROTO || "");
  return r ? "Symbol(src)_1." + r : "";
}();
function Xr(r) {
  return !!L && L in r;
}
var Qr = Xr, Yr = Function.prototype, Zr = Yr.toString;
function re(r) {
  if (r != null) {
    try {
      return Zr.call(r);
    } catch {
    }
    try {
      return r + "";
    } catch {
    }
  }
  return "";
}
var rr = re, ee = Z, te = Qr, ae = Y, ne = rr, oe = /[\\^$.*+?()[\]{}|]/g, ie = /^\[object .+?Constructor\]$/, se = Function.prototype, ce = Object.prototype, ue = se.toString, fe = ce.hasOwnProperty, ge = RegExp(
  "^" + ue.call(fe).replace(oe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function be(r) {
  if (!ae(r) || te(r))
    return !1;
  var e = ee(r) ? ge : ie;
  return e.test(ne(r));
}
var pe = be;
function le(r, e) {
  return r == null ? void 0 : r[e];
}
var ve = le, ye = pe, de = ve;
function je(r, e) {
  var t = de(r, e);
  return ye(t) ? t : void 0;
}
var j = je, me = j, $e = f, Te = me($e, "DataView"), _e = Te, he = j, Se = f, Ae = he(Se, "Map"), Oe = Ae, we = j, Pe = f, xe = we(Pe, "Promise"), ke = xe, Ee = j, Me = f, Ne = Ee(Me, "Set"), Ie = Ne, Be = j, Fe = f, Ce = Be(Fe, "WeakMap"), Le = Ce, A = _e, O = Oe, w = ke, P = Ie, x = Le, er = _, l = rr, D = "[object Map]", De = "[object Object]", R = "[object Promise]", V = "[object Set]", G = "[object WeakMap]", U = "[object DataView]", Re = l(A), Ve = l(O), Ge = l(w), Ue = l(P), Ke = l(x), p = er;
(A && p(new A(new ArrayBuffer(1))) != U || O && p(new O()) != D || w && p(w.resolve()) != R || P && p(new P()) != V || x && p(new x()) != G) && (p = function(r) {
  var e = er(r), t = e == De ? r.constructor : void 0, o = t ? l(t) : "";
  if (o)
    switch (o) {
      case Re:
        return U;
      case Ve:
        return D;
      case Ge:
        return R;
      case Ue:
        return V;
      case Ke:
        return G;
    }
  return e;
});
var He = p;
function ze(r) {
  return r != null && typeof r == "object";
}
var k = ze, We = _, Je = k, qe = "[object Arguments]";
function Xe(r) {
  return Je(r) && We(r) == qe;
}
var Qe = Xe, K = Qe, Ye = k, tr = Object.prototype, Ze = tr.hasOwnProperty, rt = tr.propertyIsEnumerable, et = K(/* @__PURE__ */ function() {
  return arguments;
}()) ? K : function(r) {
  return Ye(r) && Ze.call(r, "callee") && !rt.call(r, "callee");
}, tt = et, at = Array.isArray, nt = at, ot = 9007199254740991;
function it(r) {
  return typeof r == "number" && r > -1 && r % 1 == 0 && r <= ot;
}
var ar = it, st = Z, ct = ar;
function ut(r) {
  return r != null && ct(r.length) && !st(r);
}
var ft = ut, $ = { exports: {} };
function gt() {
  return !1;
}
var bt = gt;
$.exports;
(function(r, e) {
  var t = f, o = bt, n = e && !e.nodeType && e, s = n && !0 && r && !r.nodeType && r, u = s && s.exports === n, v = u ? t.Buffer : void 0, g = v ? v.isBuffer : void 0, y = g || o;
  r.exports = y;
})($, $.exports);
var pt = $.exports, lt = _, vt = ar, yt = k, dt = "[object Arguments]", jt = "[object Array]", mt = "[object Boolean]", $t = "[object Date]", Tt = "[object Error]", _t = "[object Function]", ht = "[object Map]", St = "[object Number]", At = "[object Object]", Ot = "[object RegExp]", wt = "[object Set]", Pt = "[object String]", xt = "[object WeakMap]", kt = "[object ArrayBuffer]", Et = "[object DataView]", Mt = "[object Float32Array]", Nt = "[object Float64Array]", It = "[object Int8Array]", Bt = "[object Int16Array]", Ft = "[object Int32Array]", Ct = "[object Uint8Array]", Lt = "[object Uint8ClampedArray]", Dt = "[object Uint16Array]", Rt = "[object Uint32Array]", a = {};
a[Mt] = a[Nt] = a[It] = a[Bt] = a[Ft] = a[Ct] = a[Lt] = a[Dt] = a[Rt] = !0;
a[dt] = a[jt] = a[kt] = a[mt] = a[Et] = a[$t] = a[Tt] = a[_t] = a[ht] = a[St] = a[At] = a[Ot] = a[wt] = a[Pt] = a[xt] = !1;
function Vt(r) {
  return yt(r) && vt(r.length) && !!a[lt(r)];
}
var Gt = Vt;
function Ut(r) {
  return function(e) {
    return r(e);
  };
}
var Kt = Ut, T = { exports: {} };
T.exports;
(function(r, e) {
  var t = q, o = e && !e.nodeType && e, n = o && !0 && r && !r.nodeType && r, s = n && n.exports === o, u = s && t.process, v = function() {
    try {
      var g = n && n.require && n.require("util").types;
      return g || u && u.binding && u.binding("util");
    } catch {
    }
  }();
  r.exports = v;
})(T, T.exports);
var Ht = T.exports, zt = Gt, Wt = Kt, H = Ht, z = H && H.isTypedArray, Jt = z ? Wt(z) : zt, qt = Jt, Xt = mr, Qt = He, Yt = tt, Zt = nt, ra = ft, ea = pt, ta = J, aa = qt, na = "[object Map]", oa = "[object Set]", ia = Object.prototype, sa = ia.hasOwnProperty;
function ca(r) {
  if (r == null)
    return !0;
  if (ra(r) && (Zt(r) || typeof r == "string" || typeof r.splice == "function" || ea(r) || aa(r) || Yt(r)))
    return !r.length;
  var e = Qt(r);
  if (e == na || e == oa)
    return !r.size;
  if (ta(r))
    return !Xt(r).length;
  for (var t in r)
    if (sa.call(r, t))
      return !1;
  return !0;
}
var ua = ca;
const fa = /* @__PURE__ */ ir(ua);
function W(r) {
  return r ? Array.from(r.querySelectorAll("button:not([disabled])")) : [];
}
const da = (r) => {
  const { isOpen: e, onClose: t, onSubmit: o, reset: n } = r, s = N(null), u = N(null);
  return or(() => {
    var y;
    if (!e) return;
    u.current = document.activeElement, (y = W(s.current)[0]) == null || y.focus();
    const g = (i) => {
      if (i.key === "Escape") {
        t == null || t();
        return;
      }
      if (i.key !== "Tab") return;
      const b = W(s.current);
      if (b.length === 0) return;
      const E = b[0], M = b[b.length - 1];
      i.shiftKey && document.activeElement === E ? (i.preventDefault(), M.focus()) : !i.shiftKey && document.activeElement === M && (i.preventDefault(), E.focus());
    };
    return document.addEventListener("keydown", g, !0), () => {
      var i, b;
      document.removeEventListener("keydown", g, !0), (b = (i = u.current) == null ? void 0 : i.focus) == null || b.call(i);
    };
  }, [e, t]), e ? /* @__PURE__ */ c(nr, { children: !fa(n) && /* @__PURE__ */ c("div", { className: "modal-overlay", ref: s, "aria-modal": "true", role: "dialog", children: /* @__PURE__ */ h("div", { className: "modal-content", children: [
    /* @__PURE__ */ h("div", { className: "u-flex u-flexAlignItemsCenter u-flexJustifyBetween", children: [
      /* @__PURE__ */ c(
        "p",
        {
          className: "u-textSizeMsrp4 heading u-paddingVert20 u-paddingHoriz20",
          dangerouslySetInnerHTML: { __html: I((n == null ? void 0 : n.heading) || "") }
        }
      ),
      /* @__PURE__ */ c("button", { className: "u-paddingHoriz20 closeButton", onClick: t, children: /* @__PURE__ */ c("span", { className: "adel-material-symbols", role: "img", title: "close", "aria-label": "Close", children: "close" }) })
    ] }),
    /* @__PURE__ */ c(
      "p",
      {
        className: "u-textSizeMsrp sub--heading u-paddingBottom20 u-paddingHoriz20",
        dangerouslySetInnerHTML: { __html: I((n == null ? void 0 : n.subHeading) || "") }
      }
    ),
    /* @__PURE__ */ c("div", { className: "modal-actions u-paddingVert20 u-flex u-marginTop20 ", children: /* @__PURE__ */ h("div", { className: "u-paddingHoriz20", children: [
      /* @__PURE__ */ c("button", { className: "Button Button--primary u-marginRight12", onClick: o, children: (n == null ? void 0 : n.submit) || "" }),
      /* @__PURE__ */ c(
        "button",
        {
          className: "Button Button--secondary Button--secondary--action-blue",
          onClick: t,
          children: (n == null ? void 0 : n.cancel) || ""
        }
      )
    ] }) })
  ] }) }) }) : null;
};
export {
  da as R,
  fa as i
};
//# sourceMappingURL=ResetTool-Xt8wU8l_.mjs.map
